import api from '@/libs/axios'
import { PaginatedList } from '../models/common/paginatedList'
import { TypeHabilitation } from '../models/options/typeHabilitations/typeHabilitation';

const resource = 'TypeHabilitations'

export default class TypeHabilitationsResource {
  public async paginatedList(pagenumber?: number, pagesize?: number, actifonly?: boolean) : Promise<PaginatedList<TypeHabilitation>> {
    const params = new URLSearchParams();
    if (pagenumber) params.append('PageNumber', pagenumber.toString()); 
    if (pagesize) params.append('PageSize', pagesize.toString()); 
    if (actifonly) params.append('ActifOnly', actifonly.toString()); 

    const response = await api.get(`${resource}`, { params: params } )
    return response.data
  }
}
